<div class="container">
    <div class="row mt-4">
        <div class="col-8">
            <h4>Lista Orientações Estratégia Torre</h4>
        </div>
        <div class="col-4 text-right">
            <span>
                <button mat-flat-button color="primary" class="mr-1 mt-2 btnSize" matTooltip="Novo Comentário"
                    (click)="openDialog(null, false, false)" skipLocationChange>
                    <i class="fa fa-plus fa-1x btnIcon"></i>
                    Novo
                </button>
            </span>

            <button mat-flat-button color="primary" (click)="showFilter()" class="btnSize"
                matTooltip="Filtro Detalhado">
                <i class="fa fa-filter fa-1x btnIcon"></i>
                Filtro
            </button>
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-12">

            <div class="table-responsive table-height">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">


                    <ng-container matColumnDef="Hibrido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="pc_hibrido"
                            class="InputLabelHeaderColor formatField"> Hibrido
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.pc_hibrido}} </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="Safra">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="safra"
                            class="InputLabelHeaderColor formatField"> Safra
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.safra}} </td>
                    </ng-container>
                    <ng-container matColumnDef="Ano">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="ano"
                            class="InputLabelHeaderColor formatField"> Ano
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.ano}} </td>
                    </ng-container> -->
                    <ng-container matColumnDef="Comentario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="comment"
                            class="InputLabelHeaderColor formatField"> Comentário
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField" [innerHTML]="row.comment"> </td>
                    </ng-container>

                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="InputLabelHeaderColor formatField">
                            Ações
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <div>

                                <span *ngIf="row.comment != '' && row.comment != null">
                                    <button mat-flat-button color="primary" class="mr-1 mt-2 btnSize"
                                        matTooltip="Editar Comentário" (click)="openDialog(row, true, false)"
                                        skipLocationChange>
                                        <i class="fa fa-edit fa-1x btnIcon"></i>
                                        Editar
                                    </button>
                                </span>
                                <span *ngIf="row.comment != '' && row.comment != null">
                                    <button mat-flat-button color="warn" class="mr-1 mt-2 btnSize"
                                        matTooltip="Excluír Comentário" (click)="openDialog(row, true, true)"
                                        skipLocationChange>
                                        <i class="fa fa-delete fa-1x btnIcon"></i>
                                        Excluír
                                    </button>
                                </span>

                            </div>
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" colspan="100%"><i class="fa fa-exclamation-warning iconWarning"
                                aria-hidden="true"></i> Nenhum registro
                            encontrado</td>
                    </tr>
                </table>
                <div class="flipped">
                    <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
                </div>

            </div>
        </div>
    </div>
</div>
<app-filter-detail>
    <app-filter-pc003-estrategia (filter)="getFilter($event)"></app-filter-pc003-estrategia>
</app-filter-detail>